import { DEFAULT_PAGE_SIZE } from '../../../helpers';

export interface PaginationInfo {
    readonly page: number;
    readonly totalNumberOfResults: number;
    readonly resultsPerPage: number;
}

export const defaultPaginationInfo: PaginationInfo = {
    resultsPerPage: DEFAULT_PAGE_SIZE,
    page: 0,
    totalNumberOfResults: 0
};
